<template>
    <div class="bg-white position-relative">
        <div class="test-program-banner-background w-100 position-absolute">&nbsp;</div>
        <div class="fw-bold text-center">
            {{ message }}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            message: { type: String, required: false, default: null }
        }
    };
</script>
<style lang="scss" scoped>
    .test-program-banner-background {
        background-image: url("Images/icons/yellow-and-black-stripes-repeat.png");
        background-position: center left;
        background-repeat: repeat-x;
        opacity: 0.2;
    }
</style>
